import type {
  ForgotPasswordRequest,
  ResetPasswordRequest,
  ChangePasswordRequest,
} from '../services/passwordApi';
import { useMutation, useQuery } from '@tanstack/react-query';
import { passwordApi } from '../services/passwordApi';

export const useForgotPassword = () => {
  return useMutation({
    mutationFn: (payload: ForgotPasswordRequest) =>
      passwordApi.forgotPassword(payload),
  });
};

export const useValidateResetToken = (token: string) => {
  return useQuery({
    queryKey: ['validateResetToken', token],
    queryFn: () => passwordApi.validateResetToken({ token }),
    enabled: !!token,
  });
};

export const useResetPassword = () => {
  return useMutation({
    mutationFn: (payload: ResetPasswordRequest) =>
      passwordApi.resetPassword(payload),
  });
};

export const useChangePassword = () => {
  return useMutation({
    mutationFn: (payload: ChangePasswordRequest) =>
      passwordApi.changePassword(payload),
  });
};